// Backend configuration for different environments
const config = {
  development: {
    backendUrl: 'http://localhost:4000/api/v1',
  },
  production: {
    backendUrl: 'https://dhs-backend-7eeabce30221.herokuapp.com/api/v1',
  },
};

// Determine the current environment
const isDevelopment = process.env.NODE_ENV === 'development';

// Export the appropriate configuration based on environment
export const backendConfig = isDevelopment ? config.development : config.production;

// Export individual URLs for convenience
export const BACKEND_URL = backendConfig.backendUrl;

// Trial period configuration
export const DEFAULT_TRIAL_PERIOD_DAYS = 0;

// Export the full config object for advanced usage
export default config;